// Imports
// ------
import styled, { css } from 'styled-components';
import { Section, ContentBlock } from '@tackl';

// Exports
// ------
export const Jacket = styled(Section)((props) => css``);

export const Cnt = styled(ContentBlock)((props) => css``);
